export default __webpack_public_path__ + "static/media/qrCodeAndroid.85fa62d6.png";